// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"fZdxO":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A SheetTrigger opens a sheet when a trigger element is pressed.
 */ parcelHelpers.export(exports, "SheetTrigger", ()=>SheetTrigger);
parcelHelpers.export(exports, "SheetOverlay", ()=>SheetOverlay);
parcelHelpers.export(exports, "Sheet", ()=>Sheet);
parcelHelpers.export(exports, "SheetBackdrop", ()=>SheetBackdrop);
parcelHelpers.export(exports, "SheetContent", ()=>SheetContent);
var _utils = require("./utils");
var _dialog = require("./Dialog");
var _filterDOMProps = require("react-aria/filterDOMProps");
var _modal = require("./Modal");
var _platform = require("react-aria/private/utils/platform");
var _mergeRefs = require("react-aria/mergeRefs");
var _pressResponder = require("react-aria/private/interactions/PressResponder");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useEffectEvent = require("react-aria/private/utils/useEffectEvent");
var _useId = require("react-aria/useId");
var _useLayoutEffect = require("react-aria/private/utils/useLayoutEffect");
var _i18Nprovider = require("react-aria/I18nProvider");
var _useObjectRef = require("react-aria/useObjectRef");
var _useOverlayTriggerState = require("react-stately/useOverlayTriggerState");
var _indexJs = require("use-sync-external-store/shim/index.js");
const InternalSheetContext = /*#__PURE__*/ (0, _react.createContext)(null);
let sheetStack = [];
let stackListeners = new Set();
function emitStackChange() {
    // Hoist every mounted sheet's timeline name to the root so a parent
    // can still resolve the child's timeline by name.
    // TODO: don't override existing timelines declared in CSS or inline styles.
    let names = Array.from({
        length: sheetStack.length
    }).map((_, i)=>`--sheet-timeline-${i}`).join(', ');
    document.documentElement.style.setProperty('timeline-scope', names);
    stackListeners.forEach((listener)=>listener());
}
function subscribeStack(listener) {
    stackListeners.add(listener);
    return ()=>{
        stackListeners.delete(listener);
    };
}
function registerSheet(config) {
    sheetStack = [
        ...sheetStack,
        config
    ];
    emitStackChange();
    return ()=>{
        sheetStack = sheetStack.filter((e)=>e.id !== config.id);
        emitStackChange();
    };
}
function getSheetStack() {
    return sheetStack;
}
const supportsViewTimeline = typeof CSS !== 'undefined' && typeof CSS.supports === 'function' && CSS.supports('animation-timeline: view()');
function SheetTrigger(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.DialogTrigger), props, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _pressResponder.PressResponder), {
        isPressed: false
    }, props.children));
}
// Additional padding added to the viewport to account for browser toolbar.
// More content than 100lvh is actually visible on iOS, even when the toolbar is collapsed.
const VIEWPORT_PADDING = (0, _platform.isIOS)() && (0, _platform.isSafari)() ? 'calc(100lvh - 100svh + 58px)' : '0px';
const viewportPadding = (after, axis)=>after && axis === 'y' ? VIEWPORT_PADDING : '0px';
const SheetOverlay = /*#__PURE__*/ (0, _react.forwardRef)(function SheetOverlay(props, domRef) {
    let { children, preventDismissal = false } = props;
    let { direction } = (0, _i18Nprovider.useLocale)();
    let position = resolveDirection(props.position ?? 'bottom', direction);
    let swipeDirection = props.swipeDirection ? resolveDirection(props.swipeDirection, direction) : position === 'center' ? 'vertical' : position;
    // Resolve the state the same way ModalOverlay does, so that swiping to close works
    // both inside a SheetTrigger and when the open state is passed directly to SheetOverlay.
    let contextState = (0, _react.useContext)((0, _dialog.OverlayTriggerStateContext));
    let localState = (0, _useOverlayTriggerState.useOverlayTriggerState)(props);
    let state = props.isOpen != null || props.defaultOpen != null || !contextState ? localState : contextState;
    let onCloseEvent = (0, _useEffectEvent.useEffectEvent)(()=>{
        state.close();
    });
    let { axis, before, after, maxScroll, enteredScroll, viewRange, viewDirection, viewIterations } = getSwipeConfig(swipeDirection);
    let id = (0, _useId.useId)();
    let stackItem = (0, _react.useMemo)(()=>({
            id,
            range: viewRange,
            direction: viewDirection,
            iterations: viewIterations
        }), [
        id,
        viewRange,
        viewDirection,
        viewIterations
    ]);
    let [isExpanded, setExpanded] = (0, _react.useState)(false);
    let isVisible = (0, _react.useRef)(false);
    let ref = (0, _react.useCallback)((element)=>{
        if (!element) return;
        // Sheets that rest at scroll 0 (top/left) mount already entered. Move them to the exit position
        // before observing, since onEnter may be deferred (e.g. while waiting for the software keyboard),
        // and the observer would otherwise see the sheet as entered and then close it once onEnter
        // jumps to the exit position.
        if (enteredScroll === 0) {
            let scroller = element.querySelector('[data-sheet-scroll]');
            if (scroller) {
                let vp = axis === 'y' ? window.innerHeight : window.innerWidth;
                scrollAlongAxis(scroller, axis, maxScroll / 100 * vp);
            }
        }
        // iOS displays content outside the reported viewport, e.g. behind the browser toolbar.
        // Add additional margin to account for that so that the sheet disappears only when it is entirely invisible.
        let rootMargin = `0px 0px ${calcToPx(viewportPadding(after, axis))} 0px`;
        let hasEntered = false;
        let observer = new IntersectionObserver((entries)=>{
            let entry = entries[0];
            // Expose whether the sheet is resting at its fully-entered detent (all of it revealed). Apps
            // can use `[data-expanded]` to only make the sheet's inner content scrollable once expanded,
            // so that at a partial detent a swipe on the content expands the sheet instead (like iOS).
            setExpanded(entry.intersectionRatio >= 1);
            isVisible.current = entry.intersectionRatio > 0;
            hasEntered ||= entry.intersectionRatio > 0;
            if (hasEntered && entry.intersectionRatio <= 0) {
                // eslint-disable-next-line react/react-compiler
                onCloseEvent();
                element.dispatchEvent(new CustomEvent('react-aria-sheet-close'));
            }
        }, {
            threshold: [
                0,
                1
            ],
            rootMargin
        });
        let el = element.querySelector('[data-sheet-content]');
        if (el) observer.observe(el);
        let removeSheet = registerSheet(stackItem);
        return ()=>{
            observer.disconnect();
            removeSheet();
        };
    }, [
        stackItem,
        axis,
        maxScroll,
        enteredScroll,
        after
    ]);
    let mergedRefs = (0, _react.useMemo)(()=>(0, _mergeRefs.mergeRefs)(ref, domRef), [
        ref,
        domRef
    ]);
    let sheetStack = (0, _indexJs.useSyncExternalStore)(subscribeStack, getSheetStack, getSheetStack);
    let index = Math.max(0, sheetStack.findIndex((e)=>e.id === id));
    let descendants = sheetStack.slice(index + 1);
    let values = {
        position,
        swipeDirection,
        isExpanded,
        stackIndex: index,
        hasDescendants: descendants.length > 0
    };
    let sheetProps = useSheetRenderProps(props, values, 'react-aria-SheetOverlay', {
        // absolute rather than fixed so the modal is not clipped by iOS Safari.
        position: 'absolute',
        top: 0,
        left: 0,
        width: 'max(var(--page-width), 100vw)',
        height: 'max(var(--page-height), 100dvh)',
        overflow: 'clip',
        // @ts-ignore
        '--sheet-scroll-padding-x': 'calc(100vw - var(--visual-viewport-width))',
        '--sheet-scroll-padding-y': 'calc(100dvh - var(--visual-viewport-height))'
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _modal.ModalOverlay), {
        ...props,
        isOpen: state.isOpen,
        defaultOpen: undefined,
        onOpenChange: state.setOpen,
        ref: mergedRefs,
        isDismissable: !preventDismissal,
        isKeyboardDismissDisabled: preventDismissal,
        // Moving the VoiceOver cursor into the sheet (via focus, or by making the content behind it
        // inert) scrolls, which interrupts the enter scroll animation on iOS. Wait until it has entered.
        UNSTABLE_deferUntilEntered: true,
        UNSTABLE_overrideFocus: true,
        ...sheetProps,
        onEnter: (element)=>{
            // The overlay is the document-anchored wrapper; the swipe gesture scrolls the inner container.
            let scroller = element.querySelector('[data-sheet-scroll]');
            let vp = axis === 'y' ? window.innerHeight + parseFloat(calcToPx(viewportPadding(after, axis))) : window.innerWidth;
            // Open at the first custom detent when provided, otherwise the fully-entered position.
            let initial = element.querySelector('[data-sheet-initial]');
            let scrollToRest = (smooth)=>{
                if (initial) scrollDetentIntoView(scroller, initial, axis, after ? 'start' : 'end', smooth);
                else scrollAlongAxis(scroller, axis, enteredScroll / 100 * vp, smooth);
            };
            if (enteredScroll === 0) {
                // The rest position is at scroll 0, so the sheet mounts already entered. Jump to the exit
                // first, then animate back in on the next frame — doing both in the same task can leave
                // the browser stuck at the jumped-to position instead of running the smooth scroll.
                scrollAlongAxis(scroller, axis, maxScroll / 100 * vp);
                requestAnimationFrame(()=>scrollToRest(true));
            } else scrollToRest(true);
            return new Promise((resolve)=>{
                // eslint-disable-next-line rsp-rules/no-non-composing-event-listener
                scroller.addEventListener('scrollend', ()=>resolve(), {
                    once: true
                });
            });
        },
        onExit: (element)=>{
            let scroller = element.querySelector('[data-sheet-scroll]');
            if (!isVisible.current) {
                // Wait for the end of the scroll gesture in Safari to avoid momentum scrolling re-targeting to the sheet behind.
                if ((0, _platform.isSafari)() && !(0, _platform.isIOS)()) return new Promise((resolve)=>{
                    // eslint-disable-next-line rsp-rules/no-non-composing-event-listener
                    scroller.addEventListener('scrollend', ()=>{
                        setTimeout(()=>resolve(), 50);
                    }, {
                        once: true
                    });
                });
                return;
            }
            let vp = axis === 'y' ? window.innerHeight + parseFloat(calcToPx(viewportPadding(after, axis))) : window.innerWidth;
            let maxScrollPx = maxScroll / 100 * vp;
            let current = axis === 'y' ? scroller.scrollTop : scroller.scrollLeft;
            let target;
            if (after && !before) target = 0;
            else if (before && !after) target = maxScrollPx;
            else // Dual direction: exit toward whichever edge is nearest the current position.
            target = current > enteredScroll / 100 * vp ? maxScrollPx : 0;
            scrollAlongAxis(scroller, axis, target, true);
            // The close event is dispatched on the overlay wrapper by the IntersectionObserver below.
            return new Promise((resolve)=>{
                element.addEventListener('react-aria-sheet-close', ()=>resolve(), {
                    once: true
                });
            });
        }
    }, (renderProps)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(InternalSheetContext.Provider, {
            value: {
                ...props,
                position,
                swipeDirection,
                index,
                descendants,
                isEntering: renderProps.isEntering,
                isExiting: renderProps.isExiting,
                values
            }
        }, typeof children === 'function' ? children({
            ...renderProps,
            ...values
        }) : children));
});
function getDataAttributes(values) {
    return {
        'data-position': values.position,
        'data-swipe-direction': values.swipeDirection,
        'data-expanded': values.isExpanded || undefined,
        'data-stack-index': values.stackIndex,
        'data-has-descendants': values.hasDescendants || undefined
    };
}
// Merges the sheet-specific values into the render props, className, and style of a Modal or ModalOverlay.
function useSheetRenderProps(props, values, defaultClassName, defaultStyle, overrideStyle) {
    return {
        ...getDataAttributes(values),
        render: props.render ? (domProps, renderProps)=>props.render(domProps, {
                ...renderProps,
                ...values
            }) : undefined,
        className: (renderProps)=>typeof props.className === 'function' ? props.className({
                ...renderProps,
                ...values
            }) : props.className || defaultClassName,
        style: (renderProps)=>({
                ...defaultStyle,
                ...typeof props.style === 'function' ? props.style({
                    ...renderProps,
                    ...values
                }) : props.style,
                ...overrideStyle
            })
    };
}
function resolveDirection(value, direction) {
    if (value === 'start') return direction === 'rtl' ? 'right' : 'left';
    if (value === 'end') return direction === 'rtl' ? 'left' : 'right';
    return value;
}
// The sheet lives inside an oversized scroll container. Scrolling slides a viewport-sized "stage"
// (which holds the sheet) on and off screen along the swipe axis, so the browser drives the swipe
// gesture natively. The container is always 2 viewports along the axis; a fixed 1-viewport window
// (the actual browser viewport) looks onto it. The stage always sits 1 viewport into the content,
// and snap markers at the content extremes define the entered/exited resting positions.
function getSwipeConfig(swipeDirection) {
    let axis = swipeDirection === 'top' || swipeDirection === 'bottom' || swipeDirection === 'vertical' ? 'y' : 'x';
    let before = swipeDirection === 'top' || swipeDirection === 'left' || swipeDirection === 'vertical' || swipeDirection === 'horizontal';
    let after = swipeDirection === 'bottom' || swipeDirection === 'right' || swipeDirection === 'vertical' || swipeDirection === 'horizontal';
    // Each exitable side adds a viewport of scroll travel.
    let maxScroll = (Number(before) + Number(after)) * 100;
    // When the sheet can only exit toward the start edge (top/left), it rests at scroll 0 and is
    // swiped toward maxScroll to dismiss. Otherwise it rests 1 viewport in.
    let enteredScroll = before && !after ? 0 : 100;
    // Position the container so the rest position lands in the real viewport.
    let containerOffset = before && !after ? -100 : 0;
    // The sheet crosses a single viewport edge (the swipe edge), so map the animation to just that
    // crossing. In view-timeline terms `entry` is the scrollport's end edge (bottom/right, where the
    // sheet appears from) and `exit` is the start edge (top/left). Direction is chosen so progress 0
    // is the exited state and 1 is entered, matching keyframes authored from exited -> entered:
    // `entry` already runs gone -> entered, while `exit` runs entered -> gone and is reversed.
    //
    // Dual directions cross both edges, so run the same keyframe over the full `cover` range twice
    // (iteration count 2) with `alternate`: the view timeline splits its progress across the two
    // iterations, so it plays exited -> entered -> exited around the centered rest position. This
    // reuses a single exited -> entered keyframe rather than requiring an author to also write a
    // symmetric (0%/50%/100%) variant.
    const viewRange = before && after ? 'cover' : before ? 'exit' : 'entry';
    const viewDirection = before && after ? 'alternate' : before ? 'reverse' : 'normal';
    const viewIterations = before && after ? 2 : 1;
    return {
        axis,
        before,
        after,
        maxScroll,
        enteredScroll,
        containerOffset,
        viewRange,
        viewDirection,
        viewIterations
    };
}
// The resting [x, y] flex alignment for each sheet position, independent of the swipe direction.
const POSITION_ALIGNMENT = {
    top: [
        'center',
        'flex-start'
    ],
    bottom: [
        'center',
        'flex-end'
    ],
    left: [
        'flex-start',
        'center'
    ],
    right: [
        'flex-end',
        'center'
    ],
    center: [
        'center',
        'center'
    ]
};
// Converts a snap point value to a CSS length: numbers are pixels.
function toLength(point) {
    return typeof point === 'number' ? `${point}px` : point;
}
function SnapPoint({ point, align, axis }) {
    let mainUnit = axis === 'y' ? 'dvh' : 'dvw';
    let offset = toLength(point);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            position: 'absolute',
            top: axis === 'y' ? offset : 0,
            left: axis === 'x' ? offset : 0,
            scrollSnapAlign: align,
            // A full viewport along the swipe axis so its start/end edge lands at the snap position.
            width: axis === 'x' ? `100${mainUnit}` : 1,
            height: axis === 'y' ? `100${mainUnit}` : 1
        }
    });
}
// A snap marker placed inside the sheet, `point` in from its leading edge. Because it moves with
// the sheet, snapping it with a `scroll-margin` of one viewport rests the marker at the edge of the
// visible viewport, leaving exactly `point` of the sheet on screen. Since `point` is an inset rather
// than part of the margin, percentages resolve relative to the sheet's size.
function DetentPoint({ point, axis, after, isInitial }) {
    let viewport = axis === 'y' ? '100dvh' : '100dvw';
    let offset = toLength(point);
    let common = {
        position: 'absolute',
        width: 1,
        height: 1,
        scrollSnapAlign: after ? 'start' : 'end'
    };
    let edge = axis === 'y' ? after ? {
        top: offset,
        left: 0,
        scrollMarginTop: viewport
    } : {
        bottom: offset,
        left: 0,
        scrollMarginBottom: viewport
    } : after ? {
        top: 0,
        left: offset,
        scrollMarginLeft: viewport
    } : {
        top: 0,
        right: offset,
        scrollMarginRight: viewport
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "data-sheet-detent": true,
        "data-sheet-initial": isInitial || undefined,
        style: {
            ...common,
            ...edge
        }
    });
}
const Sheet = /*#__PURE__*/ (0, _react.forwardRef)(function Sheet(props, domRef) {
    let ref = (0, _useObjectRef.useObjectRef)(domRef);
    let scrollRef = (0, _react.useRef)(null);
    let stageRef = (0, _react.useRef)(null);
    let { position, swipeDirection, snapPoints, index, descendants, isEntering, isExiting, preventDismissal = false, values } = (0, _react.useContext)(InternalSheetContext);
    // The ModalOverlay may defer its enter animation (e.g. until the software keyboard opens), during
    // which isEntering is false. The sheet is not settled until it has opened, so treat it as entering.
    let isOpen = (0, _react.useContext)((0, _modal.InternalModalContext))?.isOpen ?? true;
    let isTransitioning = !isOpen || isEntering || isExiting;
    let { direction } = (0, _i18Nprovider.useLocale)();
    let { axis, after, before, containerOffset } = getSwipeConfig(swipeDirection);
    let viewport = axis === 'y' ? '100dvh' : '100dvw';
    // A non-dismissable sheet can still be swiped between its snap points, but not past the smallest
    // one. Enter/exit animations still need the exit space, so only clamp while settled.
    let hasSnapPoints = !!snapPoints?.length && before !== after;
    let isClamped = preventDismissal && !isTransitioning;
    let snapTravel = useSnapPointTravel(stageRef, ref, axis, after, preventDismissal && hasSnapPoints ? snapPoints.join(' ') : null);
    // Scroll travel between the smallest snap point and the fully revealed sheet. It is at least 1px
    // so the scroll container remains scrollable, which lets the browser show its native overscroll
    // bounce even when there is nowhere to snap to.
    let clampedTravel = `${hasSnapPoints ? Math.max(1, snapTravel) : 1}px`;
    // The stage normally sits 1 viewport in so the sheet can scroll fully off screen toward the start
    // edge. When clamped, sheets exiting toward the end edge move it so scroll 0 rests at the smallest
    // snap point. Sheets exiting toward the start edge rest at scroll 0 already, so only the end of
    // the scroll content (the smallest snap point) moves. Dual direction sheets get 1px either side.
    // viewportPadding pushes bottom sheets down so that they can scroll beyond the viewport behind the iOS toolbar.
    let stageStart = isClamped && after ? clampedTravel : `calc(${viewport} + ${viewportPadding(after, axis)})`;
    let endMarker;
    if (isClamped && before && after) endMarker = `calc(${stageStart} + ${viewport} + 1px)`;
    else if (isClamped && before) endMarker = `calc(${clampedTravel} + ${viewport})`;
    else endMarker = `calc(${stageStart} + ${viewport}${before && after ? ` + ${viewport}` : ''})`;
    // Keep the sheet visually in place when switching between the clamped and unclamped geometry.
    // Scroll snapping is disabled while a non-dismissable sheet enters and exits so the browser
    // doesn't re-snap when the geometry changes, which would otherwise differ between browsers.
    let prevStageOffset = (0, _react.useRef)(null);
    let prevClamped = (0, _react.useRef)(isClamped);
    (0, _useLayoutEffect.useLayoutEffect)(()=>{
        let stage = stageRef.current;
        let scroller = scrollRef.current;
        if (!stage || !scroller) return;
        let offset = axis === 'y' ? stage.offsetTop : stage.offsetLeft;
        if (prevClamped.current !== isClamped && prevStageOffset.current != null) {
            let delta = offset - prevStageOffset.current;
            if (delta !== 0) {
                if (axis === 'y') scroller.scrollTop += delta;
                else scroller.scrollLeft += delta;
            }
        }
        prevClamped.current = isClamped;
        prevStageOffset.current = offset;
    });
    let swipeAnimation = useSwipeAnimation(props);
    let style = {
        // Positioned so the detent markers below anchor to the sheet's own box.
        position: 'relative',
        ...swipeAnimation
    };
    let overscrollInset;
    if (props.overscrollPadding && position === swipeDirection) {
        overscrollInset = axis === 'y' ? '100vh' : '100vw';
        // Extra padding to allow overscrolling, and a negative margin to offset it.
        switch(position){
            case 'top':
                style.paddingTop = '100vh';
                style.marginTop = '-100vh';
                break;
            case 'bottom':
                style.paddingBottom = '100vh';
                style.marginBottom = '-100vh';
                break;
            case 'left':
                style.paddingLeft = '100vw';
                style.marginLeft = '-100vw';
                break;
            case 'right':
                style.paddingRight = '100vw';
                style.marginRight = '-100vw';
                break;
        }
    }
    if (props.stackAnimation && descendants.length > 0 && supportsViewTimeline) {
        // Append one animation per descendant sheet, driven by that descendant's view timeline.
        let stackStyle = {
            animationName: ()=>props.stackAnimation,
            animationTimeline: (_, i)=>`--sheet-timeline-${index + 1 + i}`,
            animationDirection: (d)=>d.direction,
            animationIterationCount: (d)=>String(d.iterations),
            animationFillMode: ()=>'both',
            animationRange: (d)=>d.range,
            animationComposition: ()=>'accumulate',
            animationTimingFunction: ()=>'linear'
        };
        for (let [key, value] of Object.entries(stackStyle))style[key] = [
            style[key],
            ...descendants.map(value)
        ].filter(Boolean).join(', ');
    }
    let sheetProps = useSheetRenderProps(props, values, 'react-aria-Sheet', {
        direction
    }, style);
    let [x, y] = POSITION_ALIGNMENT[position];
    let justifyContent = axis === 'y' ? y : x;
    let alignItems = axis === 'y' ? x : y;
    let { scrollX, scrollY } = typeof window !== 'undefined' ? window : {
        scrollX: 0,
        scrollY: 0
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: scrollRef,
        "data-sheet-scroll": true,
        style: {
            position: 'absolute',
            top: axis === 'y' ? `calc(${scrollY}px + ${containerOffset}dvh)` : scrollY,
            left: axis === 'x' ? `calc(${scrollX}px + ${containerOffset}dvw)` : scrollX,
            // The container is 2 viewports along the swipe axis and 1 viewport on the cross axis.
            height: axis === 'y' ? '200dvh' : '100dvh',
            width: axis === 'x' ? '200dvw' : '100dvw',
            overflowX: axis === 'x' ? 'auto' : 'hidden',
            overflowY: axis === 'y' ? 'auto' : 'hidden',
            // Snapping is only disabled when the geometry changes. Changing it during a swipe to dismiss
            // cancels the momentum scroll in Safari without firing scrollend, which onExit waits for.
            scrollSnapType: preventDismissal && isTransitioning ? 'none' : `${axis} mandatory`,
            overscrollBehaviorY: axis === 'y' ? 'contain' : 'none',
            overscrollBehaviorX: axis === 'x' ? 'contain' : 'none',
            scrollbarWidth: 'none',
            // The scroll geometry is physical, so keep the scroll origin and flex alignment
            // left-to-right regardless of the document direction.
            direction: 'ltr'
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(SnapPoint, {
        point: 0,
        align: isClamped && after ? 'none' : 'start',
        axis: axis
    }), before && after && /*#__PURE__*/ (0, _reactDefault.default).createElement(SnapPoint, {
        point: stageStart,
        align: "start",
        axis: axis
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: stageRef,
        style: {
            position: 'absolute',
            // The stage normally sits 1 viewport into the content along the swipe axis.
            top: axis === 'y' ? stageStart : 0,
            left: axis === 'x' ? stageStart : 0,
            height: '100dvh',
            width: '100dvw',
            display: 'flex',
            flexDirection: axis === 'y' ? 'column' : 'row',
            alignItems,
            justifyContent
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _modal.Modal), {
        ...props,
        ref: ref,
        ...sheetProps
    }, (renderProps)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, snapPoints && // Excludes the overscroll padding so percentages are relative to the visible sheet.
        /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            style: {
                position: 'absolute',
                inset: 0,
                ...overscrollInset ? {
                    [position]: overscrollInset
                } : null,
                pointerEvents: 'none'
            }
        }, snapPoints.map((point, i)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(DetentPoint, {
                key: i,
                point: point,
                axis: axis,
                after: after,
                isInitial: i === 0
            }))), typeof props.children === 'function' ? props.children({
            ...renderProps,
            ...values
        }) : props.children))), /*#__PURE__*/ (0, _reactDefault.default).createElement(SnapPoint, {
        point: endMarker,
        align: isClamped && before ? 'none' : 'end',
        axis: axis
    }));
});
// Measures how far the sheet must scroll from its smallest snap point to be fully revealed, i.e. the
// distance from that snap point's marker to the stage's exit edge. Measuring the rendered markers
// means snap points can use any CSS length, including percentages of the sheet. Uses layout offsets
// rather than bounding rects so swipe/stack animation transforms don't affect it.
function useSnapPointTravel(stageRef, sheetRef, axis, after, // Space-separated snap points, so markers are re-measured when they change. Null to disable.
snapPointsKey) {
    let [travel, setTravel] = (0, _react.useState)(0);
    (0, _useLayoutEffect.useLayoutEffect)(()=>{
        let stage = stageRef.current;
        let sheet = sheetRef.current;
        if (snapPointsKey == null || !stage || !sheet) return;
        let measure = ()=>{
            let stageSize = axis === 'y' ? stage.clientHeight : stage.clientWidth;
            let max = 0;
            for (let marker of sheet.querySelectorAll('[data-sheet-detent]')){
                let offset = 0;
                let el = marker;
                while(el && el !== stage){
                    offset += axis === 'y' ? el.offsetTop : el.offsetLeft;
                    el = el.offsetParent;
                }
                // Markers sit at the snap point's start edge for sheets exiting toward the end edge, and at
                // its end edge for sheets exiting toward the start edge. The smallest snap point travels most.
                let size = axis === 'y' ? marker.offsetHeight : marker.offsetWidth;
                max = Math.max(max, after ? stageSize - offset : offset + size);
            }
            setTravel(max);
        };
        measure();
        let observer = new ResizeObserver(measure);
        observer.observe(stage);
        observer.observe(sheet);
        return ()=>observer.disconnect();
    }, [
        stageRef,
        sheetRef,
        axis,
        after,
        snapPointsKey
    ]);
    return travel;
}
const SheetBackdrop = /*#__PURE__*/ (0, _react.forwardRef)(function SheetBackdrop(props, ref) {
    let style = useSwipeAnimation(props);
    let { values, isEntering, isExiting } = (0, _react.useContext)(InternalSheetContext);
    let state = (0, _react.useContext)((0, _dialog.OverlayTriggerStateContext));
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-SheetBackdrop',
        defaultStyle: {
            ...style,
            position: 'absolute',
            inset: 0
        },
        values: {
            ...values,
            isEntering,
            isExiting,
            state
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: ref,
        ...(0, _filterDOMProps.filterDOMProps)(props, {
            global: true
        }),
        ...renderProps,
        ...getDataAttributes(values),
        "data-entering": isEntering || undefined,
        "data-exiting": isExiting || undefined
    });
});
function useSwipeAnimation(props) {
    let { swipeDirection, snapPoints, index, isEntering, isExiting } = (0, _react.useContext)(InternalSheetContext);
    let { viewRange, viewDirection, viewIterations } = getSwipeConfig(swipeDirection);
    if (props.swipeAnimation) {
        let rangeStart = props.swipeAnimationRange?.start != null ? toLength(snapPoints?.[props.swipeAnimationRange.start] ?? '0%') : '0%';
        let rangeEnd = props.swipeAnimationRange?.end != null ? toLength(snapPoints?.[props.swipeAnimationRange.end] ?? '100%') : '100%';
        if (swipeDirection === 'top' || swipeDirection === 'left') {
            rangeStart = `calc(100% - ${rangeStart})`;
            rangeEnd = `calc(100% - ${rangeEnd})`;
            [rangeStart, rangeEnd] = [
                rangeEnd,
                rangeStart
            ];
        }
        // TODO: fix cover with range
        if (supportsViewTimeline) return {
            animationName: props.swipeAnimation,
            animationTimeline: `--sheet-timeline-${index}`,
            animationDirection: viewDirection,
            animationIterationCount: viewIterations,
            animationFillMode: 'both',
            animationRange: `${viewRange} ${rangeStart} ${viewRange} ${rangeEnd}`,
            animationTimingFunction: 'linear',
            animationComposition: 'replace'
        };
        else if (isEntering || isExiting) // Fallback for Firefox, which doesn't support view timelines.
        return {
            animationName: props.swipeAnimation,
            animationDirection: isExiting ? 'reverse' : 'normal',
            animationDuration: '300ms',
            animationIterationCount: '1',
            animationFillMode: 'both',
            animationTimingFunction: 'linear',
            animationComposition: 'replace'
        };
    }
    return {};
}
const SheetContent = /*#__PURE__*/ (0, _react.forwardRef)(function SheetContent(props, ref) {
    let { swipeDirection, index } = (0, _react.useContext)(InternalSheetContext);
    let { axis, before, after } = getSwipeConfig(swipeDirection);
    let viewportLength = axis === 'y' ? '100dvh' : '100dvw';
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialog.Dialog), {
        ...props,
        ref: ref,
        className: props.className || 'react-aria-SheetContent',
        "data-sheet-content": true,
        style: {
            ...props.style,
            width: '100%',
            height: '100%',
            // The dialog is the subject of the view-progress timeline that drives all sheet animations.
            // It is _not_ the Modal because that may have additional padding for overscroll and therefore never be entirely visible.
            // The inset crops the scroll container's scrollport down to the visible viewport.
            // @ts-ignore
            viewTimelineName: `--sheet-timeline-${index}`,
            viewTimelineAxis: axis,
            viewTimelineInset: before && !after ? `${viewportLength} 0` : `0 ${viewportLength}`
        }
    });
});
function reduceMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
function scrollAlongAxis(element, axis, value, smooth = false) {
    let behavior = smooth && !reduceMotion() ? 'smooth' : undefined;
    element.scrollTo(axis === 'y' ? {
        top: value,
        behavior
    } : {
        left: value,
        behavior
    });
}
function scrollDetentIntoView(scroller, marker, axis, align, smooth = false) {
    let behavior = smooth && !reduceMotion() ? 'smooth' : 'auto';
    let markerRect = marker.getBoundingClientRect();
    let scrollerRect = scroller.getBoundingClientRect();
    let style = getComputedStyle(marker);
    if (axis === 'y') {
        if (align === 'start') {
            let margin = parseFloat(style.scrollMarginTop) || 0;
            // Rest the marker's start edge (less its scroll-margin) at the scrollport's start.
            let top = markerRect.top - scrollerRect.top + scroller.scrollTop - margin;
            scroller.scrollTo({
                top,
                behavior
            });
        } else {
            let margin = parseFloat(style.scrollMarginBottom) || 0;
            // Rest the marker's end edge (plus its scroll-margin) at the scrollport's end.
            let top = markerRect.bottom - scrollerRect.top + scroller.scrollTop + margin - scroller.clientHeight;
            scroller.scrollTo({
                top,
                behavior
            });
        }
    } else if (align === 'start') {
        let margin = parseFloat(style.scrollMarginLeft) || 0;
        let left = markerRect.left - scrollerRect.left + scroller.scrollLeft - margin;
        scroller.scrollTo({
            left,
            behavior
        });
    } else {
        let margin = parseFloat(style.scrollMarginRight) || 0;
        let left = markerRect.right - scrollerRect.left + scroller.scrollLeft + margin - scroller.clientWidth;
        scroller.scrollTo({
            left,
            behavior
        });
    }
}
function calcToPx(calc) {
    if (!calc.startsWith('calc(')) return calc;
    let measure = document.createElement('div');
    measure.inert = true;
    measure.style.position = 'absolute';
    measure.style.top = '0px';
    measure.style.left = '0px';
    measure.style.contain = 'strict';
    measure.style.height = calc;
    document.body.appendChild(measure);
    let height = window.getComputedStyle(measure).height;
    measure.remove();
    return height;
}

},{"./utils":"bA6Cz","./Dialog":"l2uUY","react-aria/filterDOMProps":"c0Owd","./Modal":"29rOq","react-aria/private/utils/platform":"hqE84","react-aria/mergeRefs":"h7MZp","react-aria/private/interactions/PressResponder":"18347","react":"a1TxN","react-aria/private/utils/useEffectEvent":"fVIcf","react-aria/useId":"de3v3","react-aria/private/utils/useLayoutEffect":"k6VV7","react-aria/I18nProvider":"l34Wn","react-aria/useObjectRef":"hJ6Rk","react-stately/useOverlayTriggerState":"4NIpq","use-sync-external-store/shim/index.js":"iKEDy","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7BUL0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sheet", ()=>Sheet);
parcelHelpers.export(exports, "Heading", ()=>(0, _dialog.Heading));
var _jsxRuntime = require("react/jsx-runtime");
var _dialog = require("react-aria-components/Dialog");
var _sheet = require("react-aria-components/Sheet");
var _sheetCss = require("./Sheet.css");
'use client';
function Sheet({ children, ...props }) {
    let { snapPoints, preventDismissal } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sheet.SheetOverlay), {
        ...props,
        style: undefined,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sheet.SheetBackdrop), {
                swipeAnimation: "sheet-backdrop",
                swipeAnimationRange: snapPoints ? {
                    start: snapPoints.length - 1
                } : undefined
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sheet.Sheet), {
                overscrollPadding: props.overscrollPadding ?? true,
                swipeAnimation: props.swipeAnimation,
                swipeAnimationRange: props.swipeAnimationRange,
                stackAnimation: "sheet-scale-back",
                style: props.style,
                children: [
                    !preventDismissal && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "sheet-handle"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sheet.SheetContent), {
                        children: children
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components/Dialog":"2f4nH","react-aria-components/Sheet":"fZdxO","./Sheet.css":"VsK0L","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"VsK0L":[function() {},{}],"35n1K":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ShoppingCart);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "8",
            cy: "21",
            r: "1",
            key: "jimo8o"
        }
    ],
    [
        "circle",
        {
            cx: "19",
            cy: "21",
            r: "1",
            key: "13723u"
        }
    ],
    [
        "path",
        {
            d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
            key: "9zh506"
        }
    ]
];
const ShoppingCart = (0, _createLucideIconJsDefault.default)("shopping-cart", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=Sheet.04d46934.js.map
